import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.GATEWAYS}-general`,
	CONFIGURATION: `${RouteNames.GATEWAYS}-configuration`,
});
